import { Link } from "react-router-dom"
import { useLocation } from "react-router-dom"

export const MenuItem = ({
  title,
  goToLink,
  menuIcon
}: {
  title: string,
  goToLink: string,
  menuIcon: React.ReactNode
}
) => {
  const location = useLocation()
  const isActive = location.pathname === goToLink || location.pathname.startsWith(`${goToLink}/`)

  return (
    <Link
      to={goToLink}
      aria-current={isActive ? 'page' : undefined}
      className={`${isActive ? 'bg-accent' : ''} w-full cursor-pointer flex flex-row justify-start items-center py-3 px-6 hover:bg-darkaccent-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent-foreground focus-visible:ring-offset-2 focus-visible:ring-offset-darkaccent`}
    >
      {menuIcon}
      <p className="font-medium text-base">{title}</p>
    </Link>
  )
}
